"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.canUseDom = void 0;
/**
 * This code has been taken from https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
 */
exports.canUseDom = !!(typeof window !== "undefined" &&
    typeof window.document !== "undefined" &&
    typeof window.document.createElement !== "undefined");
/**
 * This code has been taken from https://github.com/Wattpad/frontend/blob/7f11a5f5444cd9a7fda8d413797f3e4931caf1ea/src/client/core/utils/utilities.js#L103-L111
 */
var getCookie = function (key) {
    if (!exports.canUseDom)
        return null;
    var result = window.document.cookie.match("(?:^|; )" + encodeURIComponent(key) + "=([^;]*)");
    if (result && result.length > 0) {
        return window.decodeURIComponent(result[1]);
    }
    return null;
};
exports.getCookie = getCookie;
exports.default = {
    canUseDom: exports.canUseDom,
    getCookie: exports.getCookie,
};
